import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES, IMAGES_URL, ALL_SERVICES, PLUS_MEMBERSHIP, BUY_MEMBERSHIP } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as faqsJson from '@src/assets/i18n/mini-env/prestige/en.json';
import { environment } from '@src/environments/environment';
import { MiniEnvTabsComponent } from "@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component";


@Component({
  selector: 'app-prestige',
  imports: [...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MiniEnvSubFooterComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    MiniEnvContentBoxComponent,
    MiniEnvTallInfoCardComponent,
    MiniEnvBgContentComponent, MiniEnvTabsComponent],
  templateUrl: './prestige.component.html',
  styleUrl: './prestige.component.scss'
})
export class PrestigeComponent extends CoreClass implements OnInit {
IMAGES_URL: string = IMAGES_URL;
  faqList = faqsJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/images/people-in-kitchen.png';
  bgClass = 'father-child-bg';
  comprehensiveType: any;
  wowPlusType: any;
  dentalType: any;
  services = ['comprehensive_care', 'wow_plus', 'dental_vision'];

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient,
    private helperService : HelperService
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = 'WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP';
  // panes: any[] = [{title: 'Concierge-level Healthcare', active: false},{title: 'Dental Services', active: false},{title: 'Exclusive Discount', active: false}];

  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'With unlimited telehealth, consult doctors anytime, anywhere whether for routine check-ups or urgent care.',
      bgImage: 'd-shape-prestige'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Navigate the complexity of healthcare with a licensed Medic concierge to assist and address any concerns. ',
      bgImage: 'circles-prestige'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Flexible membership options to fit your lifestyle and medical needs, with options to add family members.',
      bgImage: 'm-shape-prestige'
    },
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'From Everday Care to Extensive Care',
    subtitle: 'WoW Health covers every aspect of efficient healthcare, with transparency. From virtual and in-person visits to labs and procedures, get major discounts.',
    buttonText: 'Start saving on healthcare',
    link: '/join',
    bannerClass: 'prestige-banner'
  }
];

  panes: any[] = [
      {tabTitle: 'Comprehesive Care', heading: 'Care that covers you fully', subHeading: 'A modern alternative to health insurance that gives you broad, access to care when you need it most. Here’s what’s included:', active: false, buttonText: 'Sign Up', btnAction:'comprehensive', pointsList: [
      {title: 'Surgeries & Procedures', description: 'Build a relationship with the same doctor, with easy appointments.'},
      {title: 'Pregnancy & Maternity', description: '24/7 medical attention with the next doctor, usually within 10-minutes.'},
      {title: 'ER Visits', description: 'Confidential mental health support, including crisis counseling 24/7.'},
      {title: 'Medications', description: 'Expert guidance via secure messaging with a wide range of providers.'}
    ]},
    {tabTitle: 'WoW Plus Benefits', heading: 'What You Get with WoW Plus', subHeading: 'Licensed Medics to guide with care decisions, with FREE virtual care.', active: false, buttonText: 'Sign Up', btnAction:'wow-plus', pointsList: [
      {title: 'Virtual Urgent Care', description: 'Build a relationship with the same doctor, with easy appointments.'},
      {title: 'Virtual Primary Care', description: '24/7 medical attention with the next doctor, usually within 10-minutes.'},
      {title: 'Mental Health Support', description: 'Confidential mental health support, including crisis counseling 24/7.'},
      {title: 'Medications & Labs', description: 'Expert guidance via secure messaging with a wide range of providers.'},
      {title: 'Dental & Vision', description: 'Expert guidance via secure messaging with a wide range of providers.'}
    ]},
    {tabTitle: 'Dental & Vision Care',heading: 'What You Get with WoW Plus', subHeading: 'Licensed Medics to guide with care decisions, with FREE virtual care.', active: false, buttonText: 'Sign Up', btnAction:'dental', pointsList: [
      {title: 'Virtual Urgent Care', description: 'Build a relationship with the same doctor, with easy appointments.'},
      {title: 'Virtual Primary Care', description: '24/7 medical attention with the next doctor, usually within 10-minutes.'},
      {title: 'Mental Health Support', description: 'Confidential mental health support, including crisis counseling 24/7.'},
      {title: 'Medications & Labs', description: 'Expert guidance via secure messaging with a wide range of providers.'},
      {title: 'Dental & Vision', description: 'Expert guidance via secure messaging with a wide range of providers.'}
    ]}
  ];

  ngOnInit(): void {
    this.setMiniEnvValues();
    this.sharedService.removeNavbarLinks = false;
    const config = this.storageService.getMiniEnvConfig(); 
    this.helperService.changeMiniEnvColor()
  }

  buttonAction(action: any) {

  const planTypes = this.storageService.getMiniEnvConfig()?.membershipPlanTypesAll;
  const plan = planTypes.split(',');

  if (action === 'comprehensive') {
    this.router.navigateByUrl(`/${BUY_MEMBERSHIP}?plan=${plan[0]}&selected=comprehensive`);
  }
  if (action === 'plus') {
    this.router.navigateByUrl(`/${BUY_MEMBERSHIP}?plan=${plan[1]}&selected=plus`);
  }
  if (action === 'dental') {
    this.router.navigateByUrl(`/${BUY_MEMBERSHIP}?plan=${plan[2]}&selected=dental`);
  }

  }

  onSliderBtnAction() {
    // this.buttonAction();
    this.goToMembership();
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

  setMiniEnvValues() {
    this.httpService.requestEntity('GET', `assets/tenant-assets/mini-env/${environment.miniEnvFile}`).subscribe((res: any) => {   
      const miniEnvConfig = res?.body;  
      if (miniEnvConfig) {
        // this.membershipPlanCode = miniEnvConfig['pegasus-einstein'].membershipPlanTypes;
        this.comprehensiveType = miniEnvConfig['prestige'].comprehensiveType;
        this.wowPlusType = miniEnvConfig['prestige'].wowPlusType;
        this.dentalType = miniEnvConfig['prestige'].dentalType;
      }
    })
  }

  goToMembership() {
    const planTypes = this.storageService.getMiniEnvConfig()?.membershipPlanTypes;
    const plan = planTypes.split(',');
    //Send Comprehensive plan
    this.router.navigateByUrl(`/${BUY_MEMBERSHIP}?plan=${plan[0]}&selected=comprehensive`);
  }

   ngAfterContentInit(): void {
    const panesArray = this.panes;

    // Ensure one tab is active
    const activePane = panesArray.find(p => p.active);
    if (!activePane && panesArray.length) {
      panesArray[0].active = true;
    }
  }

  select(index: number): void {
    this.panes.forEach((pane, i) => {
      pane.active = i === index;
    });
  }
}
